module.exports = __webpack_public_path__ + "static/img/monitor_good1.342c4c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/monitor_good1.png
// module id = +RBW
// module chunks = 1